/*___ put items in array ( replace existing indexes ) */

const arrPut = <Item = any>(arrSrc: Item[], items: Item[], index = 0): Item[] => {
    return [...arrSrc.slice(0, index), ...items, ...arrSrc.slice(index + items.length)];
};

export default arrPut;
